import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { getAccessToken } from "layouts/AuthUtils.js";

const PrivateRoute = ({ component: Component, requiredEndpoint, ...rest }) => {
  const [accessToken, setAccessToken] = useState(null); // Token state
  const [loading, setLoading] = useState(true); // Loading state
  const [isAuthenticated, setIsAuthenticated] = useState(false); // Authentication status

  useEffect(() => {
    const fetchToken = async () => {
      const token = await getAccessToken(); // Gets token or refreshes it
      setAccessToken('token');
      console.log("token ", token)
      setIsAuthenticated(!!token); // Sets authentication state
      setLoading(false);
    };
  
    fetchToken();
  }, []);

  const selectedEndpoint = localStorage.getItem("selectedEndpoint");

  // Show loading indicator until the token check is complete
  if (loading) {
    return <div>Loading...</div>;
  }
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthenticated) {
          // If not authenticated, redirect to sign-in page
          return <Redirect to="/auth/signin" />;
        }
        else if (requiredEndpoint && selectedEndpoint !== requiredEndpoint) {
          // If authenticated but the endpoint does not match, redirect to dashboard
          return <Redirect to="/admin/dashboard" />;
        }
        else {
        // If authenticated and the endpoint matches, render the component
        return <Component {...props} />;
      }
      }}
    />
  );
};

export default PrivateRoute;
